'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterBarProps {
  selectedCategory: string;
  selectedProgram: string;
  selectedAgeGroup: string;
  searchQuery: string;
  onCategoryChange: (category: string) => void;
  onProgramChange: (program: string) => void;
  onAgeGroupChange: (ageGroup: string) => void;
  onSearchChange: (query: string) => void;
}

const FilterBar = ({
  selectedCategory,
  selectedProgram,
  selectedAgeGroup,
  searchQuery,
  onCategoryChange,
  onProgramChange,
  onAgeGroupChange,
  onSearchChange,
}: FilterBarProps) => {
  const categories = ['All Stories', 'Transformations', 'Athletes', 'Parents', 'Videos'];
  const programs = ['All Programs', 'Speed Training', 'Strength & Conditioning', 'General Fitness', 'Kids Foundation'];
  const ageGroups = ['All Ages', 'Kids (6-12)', 'Teens (13-17)', 'Adults (18-54)', 'Seniors (55+)'];

  return (
    <div className="bg-card rounded-lg shadow-card p-6 mb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-heading font-semibold text-text-primary mb-2">
            Category
          </label>
          <select
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="w-full px-4 py-2 border border-border rounded-md bg-background text-text-primary focus:outline-none focus:ring-2 focus:ring-accent"
          >
            {categories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-heading font-semibold text-text-primary mb-2">
            Program
          </label>
          <select
            value={selectedProgram}
            onChange={(e) => onProgramChange(e.target.value)}
            className="w-full px-4 py-2 border border-border rounded-md bg-background text-text-primary focus:outline-none focus:ring-2 focus:ring-accent"
          >
            {programs.map((program) => (
              <option key={program} value={program}>
                {program}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-heading font-semibold text-text-primary mb-2">
            Age Group
          </label>
          <select
            value={selectedAgeGroup}
            onChange={(e) => onAgeGroupChange(e.target.value)}
            className="w-full px-4 py-2 border border-border rounded-md bg-background text-text-primary focus:outline-none focus:ring-2 focus:ring-accent"
          >
            {ageGroups.map((ageGroup) => (
              <option key={ageGroup} value={ageGroup}>
                {ageGroup}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-heading font-semibold text-text-primary mb-2">
            Search
          </label>
          <div className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search stories..."
              className="w-full px-4 py-2 pl-10 border border-border rounded-md bg-background text-text-primary focus:outline-none focus:ring-2 focus:ring-accent"
            />
            <Icon
              name="MagnifyingGlassIcon"
              size={18}
              variant="outline"
              className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;